import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from '../../../../core/design-system/components/BackButton';
import { Icon } from '../../../../core/design-system/components/Icon';
import { usePreferences } from '../../../../shared/hooks/usePreferences';
import LanguageContent from '../PreferencesSettingsPage/components/LanguageContent';
import ThemeContent from '../PreferencesSettingsPage/components/ThemeContent';
import './styles.css';

const AppearanceSettingsPage = ({ hideHeader = false, onSubSectionChange }) => {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();
  const [currentSection, setCurrentSection] = useState(null);
  const { isLoading, get, set } = usePreferences();

  useEffect(() => {
    if (onSubSectionChange) {
      onSubSectionChange(currentSection !== null);
    }
  }, [currentSection, onSubSectionChange]);

  const handleBack = () => {
    if (currentSection) {
      setCurrentSection(null);
    } else if (!hideHeader) {
      navigate(-1);
    }
  };

  const appearanceItems = [
    {
      id: 'language',
      label: t('pages.appearance.language.title'),
      component: LanguageContent,
      props: {
        selectedLanguage: get('language') || 'fr',
        onLanguageChange: (value) => set('language', value)
      }
    },
    {
      id: 'theme',
      label: t('pages.appearance.theme.title'),
      component: ThemeContent,
      props: {
        currentTheme: get('theme') || 'system',
        onThemeChange: (value) => set('theme', value)
      }
    }
  ];

  const renderMainList = () => (
    <div className="appearance-list">
      {appearanceItems.map((item) => (
        <button
          key={item.id}
          className="appearance-item"
          onClick={() => setCurrentSection(item.id)}
        >
          <div className="appearance-item-content">
            <span className="appearance-item-label">{item.label}</span>
          </div>
          <Icon name="chevron-right" size={20} className="appearance-item-arrow" />
        </button>
      ))}
    </div>
  );

  const renderContent = () => {
    if (!currentSection) {
      return renderMainList();
    }

    const currentItem = appearanceItems.find(item => item.id === currentSection);
    if (!currentItem) return null;

    return React.createElement(currentItem.component, {
      ...currentItem.props
    });
  };

  if (isLoading) {
    return <div className="appearance-loading">{t('common.loading')}</div>;
  }

  return (
    <div className="appearance-page">
      {!hideHeader && currentSection === null && (
        <header className="appearance-header">
          <BackButton onClick={handleBack} />
          <h1 className="appearance-title">{t('pages.appearance.title')}</h1>
        </header>
      )}
      {currentSection && (
        <header className="appearance-header">
          <BackButton onClick={handleBack} />
          <h1 className="appearance-title">
            {t(`pages.appearance.${currentSection}.title`)}
          </h1>
        </header>
      )}
      <div className="appearance-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default AppearanceSettingsPage;

